import React from "react"
import createTemplate from "../../create-template"

import { useComponents } from "../../components"

function HawthorneThankYou({ styles, ...props }) {
  const Elements = useComponents()
  const backgroundColor = styles.forElement("page").backgroundColor

  return (
    <Elements.LandingPage
      styles={styles}
      {...props}
      style={styles.forElement("page")}
    >
      <div className="formkit-container">
        <div className="formkit-content-container">
          <Elements.Heading name="name" defaults={{ content: "Name" }} />
          <div>
            <div className="formkit-card" style={{ backgroundColor }}>
              <Elements.Heading
                name="header"
                defaults={{ content: "Thank you for signing up" }}
              />
              <Elements.Region name="content" className="formkit-content">
                <Elements.Content
                  defaults={{
                    content: "Provide some more detail in this subtitle"
                  }}
                />
              </Elements.Region>
            </div>
            <Elements.Content
              name="disclaimer"
              defaults={{
                content: "We respect your privacy. Unsubscribe at anytime."
              }}
            />
          </div>
          <Elements.BuiltWith background="page" />
          {/* This empty div helps center elements (via flex). */}
          <div />
        </div>
        <div
          className="formkit-background"
          style={{
            backgroundColor: styles.forElement("background").backgroundColor
          }}
        />
        <div
          className="formkit-background"
          style={styles.forElement("background")}
        />
      </div>
    </Elements.LandingPage>
  )
}

HawthorneThankYou.style = "landing_page"
HawthorneThankYou.categories = ["Newsletter"]
HawthorneThankYou.thumbnail = ""
HawthorneThankYou.preview = "https://pages.convertkit.com/23e999071c/eb41389962"
HawthorneThankYou.fields = []

export default createTemplate(HawthorneThankYou, { name: "HawthorneThankYou" })
